'use strict';



var bssslidein = angular.module("bss.slidein", [])
    .directive("bssslidein", [require("./BSSSlidein")])
;

module.exports = bssslidein;